import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore.ts';

const RootRedirect = () => {
    const { isUser } = useAuthStore();
    return (
        <Navigate to={isUser() ? '/user/dashboard' : '/dashboard'} replace />
    );
};

export default RootRedirect;
